export const UPDATE_KPI_STATE = 'UPDATE_KPI_STATE'
export const KPI_FILTER_AND_DATA_LOADED = 'KPI_FILTER_AND_DATA_LOADED'


// WEBPACK FOOTER //
// ./src/data/redux/kpi_details/actiontypes.js